import React, { useEffect, useState } from 'react';
import { ContenidosExternosService } from './ContenidosExternosService';
import { ContenidoExternoModel, GetContenidosExternosResult } from '../models/dataModels';
import { Loading } from '../utils/Loading';

/*
Pseudocode:
- Keep existing data + loading state.
- Add state: openIndex (number | null) to track which FAQ is expanded.
- On click of an item's header:
  - If openIndex === clicked index -> set openIndex to null (collapse).
  - Else set openIndex to clicked index (expand).
- Remove bootstrap data-bs attributes and id usage for collapse.
- Add aria-expanded attribute based on state for accessibility.
- Render content div only when openIndex === index (or use style/display).
- Keep existing mapping and inner HTML rendering.
*/

export const Faqs: React.FC = () => {
    const [data, setData] = useState<GetContenidosExternosResult | null>(null);
    const [loading, setLoading] = useState<boolean>(true);
    const [openIndex, setOpenIndex] = useState<number | null>(null);

    useEffect(() => {
        setLoading(true);
        const service = new ContenidosExternosService();
        service.getFaqsUrl().then(p => {
            setData(p);
            setLoading(false);
        });
    }, []);

    const toggle = (index: number) => {
        setOpenIndex(prev => (prev === index ? null : index));
    };

    if (loading || data == null) {
        return <Loading />;
    }

    return <>
        {data.contenidos != null &&
            <div>

                <h3>Preguntas frecuentes</h3>
                <div className="ps-3 pt-4">
                    <a href="https://elbancodelibros.com/media/rqpd2wii/formacio-n-hub-de-licencias-digitales.pdf" download target="_blank">
                        <img src="/img/ic-informes.svg" alt="Compromisos" style={{ width: "50px" }} className="ic-menu pe-3" />
                            Desde aqui puede descargar manual del hub
                    </a>
                </div>
                <div className="ps-3 pt-4">
                    {data.contenidos.map((contenido: ContenidoExternoModel, i: number) => {
                        const expanded = openIndex === i;
                        return (
                            <div key={i}>
                                <h4
                                    className="pointer"
                                    role="button"
                                    aria-expanded={expanded}
                                    aria-controls={`faq-panel-${i}`}
                                    onClick={() => toggle(i)}
                                    style={{ userSelect: 'none' }}
                                >
                                    <a className="link-offset-2 link-offset-3-hover link-underline link-underline-opacity-0 link-underline-opacity-75-hover" href="#">
                                        {contenido.titulo}
                                    </a>
                                </h4>
                                {expanded && (

                                    <div
                                        id={`faq-panel-${i}`}
                                        className="card card-body"
                                        dangerouslySetInnerHTML={{ __html: contenido.contenido }}
                                    />

                                )}
                            </div>
                        );
                    })}
                </div>
            </div>
        }
    </>;
};
